export const COUNTRY_CONFIG = {
  korea: {
    id: 'korea',
    flag: '\uD83C\uDDF0\uD83C\uDDF7',
    label: '\u97D3\u570B\u9023\u7DDA',
    collection: 'koreanProducts',
    searchCountry: 'korea',
    simple: false,
  },
  japan: {
    id: 'japan',
    flag: '\uD83C\uDDEF\uD83C\uDDF5',
    label: '\u65E5\u672C\u9023\u7DDA',
    collection: 'japanProducts',
    searchCountry: 'japan',
    simple: false,
  },
  thailand: {
    id: 'thailand',
    flag: '\uD83C\uDDF9\uD83C\uDDED',
    label: '\u6CF0\u570B\u9023\u7DDA',
    collection: 'thaiProducts',
    searchCountry: 'thailand',
    simple: false,
  },
  china: {
    id: 'china',
    flag: '\uD83C\uDDE8\uD83C\uDDF3',
    label: '\u5927\u9678\u9023\u7DDA',
    collection: 'chinaProducts',
    searchCountry: 'china',
    simple: false,
  },
  crystal: {
    id: 'crystal',
    flag: '\uD83D\uDC8E',
    label: '\u6C34\u6676\u5546\u54C1',
    collection: 'crystalProducts',
    searchCountry: 'crystal',
    simple: true,
  },
};

export const HOME_COUNTRIES = Object.values(COUNTRY_CONFIG).map(({ id, flag, label }) => ({
  id,
  flag,
  label,
}));

export const VALID_COUNTRY_IDS = Object.keys(COUNTRY_CONFIG);

export const getCollectionName = (country) => COUNTRY_CONFIG[country]?.collection || 'thaiProducts';

export const isSimpleProductCountry = (country) => Boolean(COUNTRY_CONFIG[country]?.simple);

export const getCountryLabel = (country) => COUNTRY_CONFIG[country]?.label || country;